import type { CSSProperties } from "react";
import Ic from "./icons.jsx";

/**
 * A short note on a document carried over from the ERP. The portal shows such a document and the
 * import keeps it fresh, but it is changed only in the ERP, so the screen offers no edit actions.
 */
export function ErpReadOnlyNote({ text }: { text: string }) {
  return (
    <div role="note" style={note}>
      <Ic.info width={15} height={15} aria-hidden style={{ flex: "none" }} />
      <span>{text}</span>
    </div>
  );
}

const note: CSSProperties = {
  display: "flex", alignItems: "center", gap: 8,
  padding: "8px 12px", borderRadius: "var(--r-sm)",
  background: "var(--surface-2)", border: "1px solid var(--border)",
  color: "var(--ink-2)", fontSize: 12.5,
};
